import { render } from "./CTAContactoAsesorCelular.vue?vue&type=template&id=fe216536"
const script = {}

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__